module.exports = __webpack_public_path__ + "static/media/get-started-1-3.df4f5260.svg";